module.exports = __webpack_public_path__ + "ce1d57ffa43815ba0dac628b6b0c668c.png";